import React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { cn } from "./utils";

// A segmented control (Radix ToggleGroup, single choice: items are radios).
// onValueChange ignores "", so clicking the active item does not clear it.
export const SegmentedControl = React.forwardRef(({ className, onValueChange, size = "default", ...props }, ref) => (
  <ToggleGroupPrimitive.Root
    ref={ref}
    type="single"
    onValueChange={(value) => value && onValueChange && onValueChange(value)}
    className={cn(
      "tw-inline-flex tw-items-center tw-gap-0.5 tw-rounded-md tw-border tw-bg-muted tw-p-0.5",
      size === "sm" ? "tw-h-7" : "tw-h-9",
      className,
    )}
    {...props}
  />
));
SegmentedControl.displayName = "SegmentedControl";

export const SegmentedItem = React.forwardRef(({ className, size = "default", ...props }, ref) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      "tw-inline-flex tw-h-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1 tw-whitespace-nowrap tw-rounded tw-bg-transparent tw-font-sans tw-font-medium tw-leading-4 tw-text-muted-foreground tw-transition-colors hover:tw-text-foreground focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=on]:tw-bg-background data-[state=on]:tw-text-foreground tw-border tw-border-transparent data-[state=on]:tw-border-border [&_svg]:tw-size-3.5",
      size === "sm" ? "tw-px-2 tw-text-xs" : "tw-px-3 tw-text-sm",
      className,
    )}
    {...props}
  />
));
SegmentedItem.displayName = "SegmentedItem";
